
<div class="customer-favorites">
  <h1>Mes provider favoris ({{ (myKeepCars$  | async)?.length}})</h1>

  <div class="buttons-section">
  </div>
  <!--
  <div class="cars-section" *ngIf="((myBuyCars$  | async) != undefined )">
    <div *ngFor="let car of (myBuyCars$  | async)!; index as i" id="{{car.id}}" class="car-section">

      <app-car-card
        [car]="car"
        [fetchingResults]="(fetchingResults$ | async)!"
        [carImagesFolder]="(carImagesFolders$ | async)!.get(car.id)!">
      </app-car-card>
    </div>
  </div> -->

  @if (((myKeepCars$  | async) !== undefined )) {
    <div>
      <app-car-card-list
        [fetchingResults]="(fetchingResults$ | async)!"
        [cars]="(myKeepCars$ | async)!"
        [businessLine]="businessLine!"
        >
      </app-car-card-list>
    </div>
  }
  <!--
  <app-alerts
    [alerts]="(myProfile$ | async)!.alerts"
    >
  </app-alerts> -->
</div>

